export default __webpack_public_path__ + "static/media/advantages-03.6ecd4775.svg";